module.exports = __webpack_public_path__ + "static/media/growth.c5c7f327.svg";